import { gql } from '@apollo/client';

const USER_SIGNATURE_QUERY = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      signature
    }
  }
`;

export default USER_SIGNATURE_QUERY;
